import { render, staticRenderFns } from "./tabControl.vue?vue&type=template&id=c3d2227e&scoped=true&"
import script from "./tabControl.vue?vue&type=script&lang=js&"
export * from "./tabControl.vue?vue&type=script&lang=js&"
import style0 from "./tabControl.vue?vue&type=style&index=0&id=c3d2227e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d2227e",
  null
  
)

export default component.exports